import Axios from "axios";

const submitSupport = async (
  email: string,
  name: string,
  subject: string,
  message: string
) => {
  try {
    const res = await Axios.post(
      "https://us-central1-iadr-4224d.cloudfunctions.net/sendMail",
      {
        from: `${email} <${name}>`,
        replyTo: email,
        to: "seaade.iadr.2020@gmail.com",
        subject,
        text: message,
      }
    );

    return res;
  } catch (error) {
    throw error;
  }
};

export default submitSupport;
